// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__mn7Z-","title":"Navbar_title__TFJhX"};